import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { language, setLanguage, t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-header">
          <div className="lang-switcher">
            <span
              className={`lang-link ${language === 'da' ? 'active' : ''}`}
              onClick={() => setLanguage('da')}
            >
              Dansk
            </span>
            <span className="lang-divider">|</span>
            <span
              className={`lang-link ${language === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
            >
              English
            </span>
          </div>
          <div className="need-help">
            <span className="help-icon">?</span>
            <span className="help-phone">87 47 60 40</span>
          </div>
        </div>

        <div className="login-form-container">
          <div className="login-logo">
            <img src={`${process.env.PUBLIC_URL}/logo-olelarsen-white.png`} alt="Ole Larsen" className="logo-image" />
            <div className="logo-subtitle">FAST <span className="track-text">TRACK</span></div>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label>{t('emailAddress')}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>{t('password')}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn-signin" disabled={loading}>
              {loading ? t('signingIn') : t('signIn')}
            </button>
          </form>

          <div className="new-customer">
            <p className="new-customer-title">{t('areYouNewCustomer')}</p>
            <p className="new-customer-text">
              {t('toAccessFastTrack')} <strong>87 47 60 40</strong>
            </p>
          </div>
        </div>
      </div>

      <div
        className="login-right"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/truck2.jpg)` }}
      >
        <div className="truck-image-overlay"></div>
      </div>
    </div>
  );
}

export default Login;
